import "core-js/modules/es.array.reduce.js";
import React, { useRef, useState } from "react";
import { Link } from "gatsby";
import last from "lodash.last";
import Img from "gatsby-image";
import SEO from "../components/seo";
import Layout from "../components/layout";
import DOMWindow from "../util/dom-wrapper/window";
import BookTemplate from "../components/article/book-template";
var AuthorTemplate = function AuthorTemplate(props) {
    var author = props.author;
    var image = null;
    if (author.picture && author.picture.fixed) {
        image = /*#__PURE__*/ React.createElement(Img, {
            fixed: author.picture.fixed,
            key: "current-author-index",
            className: "rounded-full mb-3",
            style: {
                width: "100px",
                height: "100px"
            }
        });
    }
    var description = /*#__PURE__*/ React.createElement("div", {
        className: "mb-10"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-4",
        dangerouslySetInnerHTML: {
            __html: author.description
        }
    }), /*#__PURE__*/ React.createElement(Link, {
        to: "/autoren/" + author.slug + "/artikel/",
        className: "font-bold text-makroOrange"
    }, "\xBB Alle Artikel dieses Autors"));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, image, description);
};
var AuthorBooks = function AuthorBooks(props) {
    var books = props.books;
    return /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mt-4"
    }, books && books.map(function (book, index) {
        return /*#__PURE__*/ React.createElement(BookTemplate, {
            book: book,
            key: index
        });
    }));
};
var AuthorsList = function AuthorsList(_ref) {
    var groupedAuthors = _ref.groupedAuthors, setAuthor = _ref.setAuthor;
    var collator = new Intl.Collator("de");
    return /*#__PURE__*/ React.createElement(React.Fragment, null, Object.keys(groupedAuthors).sort(collator.compare).map(function (group) {
        return /*#__PURE__*/ React.createElement("div", {
            key: group,
            className: "w-full sm:pr-2 sm:mb-2 sm:w-1/2 md:w-1/3 lg:w-1/4"
        }, /*#__PURE__*/ React.createElement("div", {
            key: "letter" + group,
            className: "font-bold text-makroOrange my-1"
        }, group), groupedAuthors[group].map(function (author, index) {
            var firstname = author.firstname, lastname = author.lastname, name = author.name;
            var displayName = firstname && lastname ? firstname + " " + lastname : name;
            return /*#__PURE__*/ React.createElement("div", {
                className: "my-1",
                key: firstname + "-" + lastname + "-" + index
            }, /*#__PURE__*/ React.createElement("button", {
                onClick: function onClick() {
                    return setAuthor(author);
                },
                className: "font-bold text-left"
            }, displayName));
        }));
    }));
};
var AuthorsPage = function AuthorsPage(_ref2) {
    var data = _ref2.data;
    var authors = data.allDatoCmsAuthor.nodes;
    var _useState = useState(authors[0]), author = _useState[0], setAuthor = _useState[1];
    var currentAuthor = author;
    var templateRef = useRef(null);
    var selectAuthor = function selectAuthor(author) {
        setAuthor(author);
        if (templateRef.current) {
            var position = templateRef.current.getBoundingClientRect().top;
            var offset = 15;
            DOMWindow.scrollBy({
                left: 0,
                top: position - offset,
                behavior: "smooth"
            });
        }
    };
    var groupedAuthors = authors.reduce(function (acc, author) {
        var lastName = author.lastname || last(author.name.split(" "));
        var firstChar = lastName.charAt(0).toUpperCase();
        if (!acc[firstChar]) {
            acc[firstChar] = [];
        }
        acc[firstChar].push(author);
        return acc;
    }, {});
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Unsere Autoren"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "border-t-8 border-solid border-makroOrange pb-8"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Unsere Autoren"), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap text-lg content-text"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full px-3 lg:pl-8 lg:w-2/3 lg:pr-4"
    }, /*#__PURE__*/ React.createElement("p", null, "Die MAKROSKOP-Redaktion freut sich auf neue Gesichter."), /*#__PURE__*/ React.createElement("p", null, "Wir suchen talentierte Autorinnen und Autoren, die fundierte Kenntnisse \xFCber gesamtwirtschaftliche Zusammenh\xE4nge und/oder einen wachen Blick auf das politische Zeitgeschehen mitbringen. Bei uns z\xE4hlen nicht bekannte Namen, sondern interessante Inhalte."), /*#__PURE__*/ React.createElement("p", null, "F\xFChlen Sie sich angesprochen?"), /*#__PURE__*/ React.createElement("p", null, "Dann werden Sie Teil der Makroskopen und schicken uns ein formloses Schreiben (gerne auch mit einer Leseprobe) an", " ", /*#__PURE__*/ React.createElement("a", {
        href: "mailto:redaktion@makroskop.eu"
    }, "redaktion@makroskop.eu"), "."))), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap mt-12"
    }, /*#__PURE__*/ React.createElement("div", {
        ref: templateRef,
        className: "w-full pt-1 lg:w-1/3 lg:pr-4"
    }, /*#__PURE__*/ React.createElement(AuthorTemplate, {
        author: currentAuthor
    }), /*#__PURE__*/ React.createElement(AuthorBooks, {
        books: author.books
    })), /*#__PURE__*/ React.createElement("div", {
        className: "w-full flex flex-wrap items-start lg:w-2/3 lg:pl-2"
    }, /*#__PURE__*/ React.createElement(AuthorsList, {
        groupedAuthors: groupedAuthors,
        setAuthor: selectAuthor
    })))));
};
var query = "3045387127";
export default AuthorsPage;
